var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "share-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1",
    transform: "translate(-144.000000, -930.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(134.000000, 920.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share-outline",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1701839,15.0778556 C17.3687962,15.0785204 16.5996428,15.3951719 16.0279863,15.9597732 L7.96924291,12.3500638 L7.96924291,12.0013987 L7.96924291,11.6629885 L16.0279863,8.04302428 C17.0687346,9.06855247 18.6844755,9.21402446 19.8899353,8.39073188 C21.0953951,7.56743929 21.5561124,6.00380905 20.9911433,4.65333802 C20.4261743,3.30286699 18.9922725,2.54025054 17.5638268,2.83052983 C16.1353811,3.12080911 15.1087214,4.3834446 15.1099016,5.84848507 L15.1099016,6.19715018 L7.05115822,9.80685953 C5.85054373,8.62106368 3.92273973,8.63249139 2.73611923,9.83243838 C1.54949872,11.0323854 1.54949872,12.9704121 2.73611923,14.1703591 C3.92273973,15.3703061 5.85054373,15.3817338 7.05115822,14.1959379 L15.1099016,17.8159021 L15.1099016,18.1543124 C15.1099016,19.8533926 16.4800367,21.2307692 18.1701839,21.2307692 C19.8603311,21.2307692 21.2304662,19.8533926 21.2304662,18.1543124 C21.2304662,16.4552322 19.8603311,15.0778556 18.1701839,15.0778556 Z M18.1701839,4.82299946 C18.7335663,4.82299946 19.190278,5.28212501 19.190278,5.84848507 C19.190278,6.41484514 18.7335663,6.87397068 18.1701839,6.87397068 C17.6068015,6.87397068 17.1500898,6.41484514 17.1500898,5.84848507 C17.1500898,5.28212501 17.6068015,4.82299946 18.1701839,4.82299946 Z M4.90896061,13.0268843 C4.34557819,13.0268843 3.88886651,12.5677588 3.88886651,12.0013987 C3.88886651,11.4350387 4.34557819,10.9759131 4.90896061,10.9759131 C5.47234302,10.9759131 5.92905471,11.4350387 5.92905471,12.0013987 C5.92905471,12.5677588 5.47234302,13.0268843 4.90896061,13.0268843 Z M18.1701839,19.179798 C17.6068015,19.179798 17.1500898,18.7206725 17.1500898,18.1543124 C17.1500898,17.5879523 17.6068015,17.1288268 18.1701839,17.1288268 C18.7335663,17.1288268 19.190278,17.5879523 19.190278,18.1543124 C19.190278,18.7206725 18.7335663,19.179798 18.1701839,19.179798 Z",
    id: "Shape",
    fill: "#1D2B7D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.f71011b0703c1c3385aeb9eaf92f013d.svg";
export { ForwardRef as ReactComponent };